const css = `.yly1Kq__icon{cursor:pointer}.yly1Kq__disabled{pointer-events:none}.yly1Kq__previous{margin-left:20%}.yly1Kq__next{margin-right:20%}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"next":"yly1Kq__next","previous":"yly1Kq__previous","disabled":"yly1Kq__disabled","icon":"yly1Kq__icon"};
